import debounce from './debounce';

$(() => {

	var postHeight = -150;

	function getHeight() {
		postHeight = postHeight + $('.yco-single.yco-single--post').outerHeight(true);
	}

	$(window).scroll(function (e) {
		if (window.matchMedia('(min-width: 768px)')) {
			var $el = $('.yco-social-media.yco-social-media--box');

			if ($(this).scrollTop() > postHeight && $el.hasClass('fixed')){
				$el.addClass('fade');
				$el.removeClass('fixed');
			}

			if ($(this).scrollTop() < postHeight && !$el.hasClass('fixed')){
				$el.removeClass('fade');
				$el.addClass('fixed');
			}
		}
	});

	$(document).ready(debounce(() => {
			if (window.matchMedia('(min-width: 768px)')) {
				getHeight();
			}
		}, 100)
	);

	$(window).resize(debounce(() => {
			if (window.matchMedia('(min-width: 768px)')) {
				getHeight();
			}
		}, 200)
	);
});





// WEBPACK FOOTER //
// ./assets/scripts/social-sticky.js